import { Menu } from 'antd'
import {useState} from 'react'
import { Link, useHistory } from 'react-router-dom'
import './left-nav.less'
import logo from "../../assets/images/logo.png"
import menuList from "../../config/menuConfig"
const { SubMenu } = Menu
const getMenuNodes = list => {
    return list.map(item => {
        if (!item.children) {
            return (
                <Menu.Item key={item.key} icon={item.icon}>
                    <Link to={item.key}>
                        {item.title}
                    </Link>
                </Menu.Item>
            )
        } else {
            return (
                <SubMenu key={item.key} title={item.title} icon={item.icon}>
                    {getMenuNodes(item.children)}
                </SubMenu>
            )
        }
    })
}

const rootKeys=list=>{
    return list.map(item=>{
        return item.key
    })
}
const rootSubmenuKeys=rootKeys(menuList)
const LeftNav = props => {
    const history = useHistory()
    const path = history.location.pathname
    const subpath = path.substring(0, path.lastIndexOf("/"))
    const [openKeys, setOpenKeys] = useState([path]);

    const onOpenChange = keys => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          setOpenKeys(keys);
        } else {
          setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
      };
      
    return (
        <div className="left-nav">
            {/* <Link to="/">
                <div className="left-nav-header">
                    <img src={logo} alt="" />
                </div>
            </Link> */}
            <div className="left-nav-menu">
                <Menu
                    selectedKeys={[path]}
                    defaultOpenKeys={[subpath]}
                    openKeys={openKeys}
                    onOpenChange={onOpenChange}
                    mode="inline"
                    theme="dark"
                >
                    {
                        getMenuNodes(menuList)
                    }
                </Menu>
            </div>
        </div>
    )
}
export default LeftNav